import {ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TdoClientConfigurationModel} from '../../../models/clients/tdo-client-configuration.model';
import {MatSort} from '@angular/material/sort';
import {TdoEnterpriseConfigurationModel} from '../../../models/configuration/tdo-enterprise-configuration.model';
import {FileManagerService} from '../../file-manager/file-manager.service';
import {DocumentUploadModel} from '../../../models/document/document-upload.model';
import {DocumentClassEnum} from '../../../models/enum/document/document-class.enum';
import {DocumentTypeEnum} from '../../../models/enum/document/document-type.enum';
import {FileHelperService} from '../../../services/file-helper.service';
import {Globals} from '../../../globals';
import {Constants} from '../../../constants';
import {DocumentDataModel} from '../../../models/document/document-data.model';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {MatTabChangeEvent} from '@angular/material/tabs';
import {EnterpriseService} from '../../../services/enterprise.service';
import {OrganizationConfigurationDialogComponent} from '../organization-configuration/dialogs/organization-configuration-dialog/organization-configuration-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {LocalStorageService} from '../../../services/local-storage.service';
import {TdoTableSelectionEvent} from '../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import {TdoTableV2Component} from '../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import {ConfigurationService} from '../configuration.service';
import {ORGANIZATION_TYPE} from '../../../models/constants/organization-type.model';

@Component({
    selector: 'app-enterprise-information',
    templateUrl: './enterprise-information.component.html',
    styleUrls: ['./enterprise-information.component.scss']
})
export class EnterpriseInformationComponent implements OnInit {
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('fileInput') fileInput: ElementRef;
    @ViewChild('clientTable') clientTable: TdoTableV2Component;

    // Client
    clientList: TdoClientConfigurationModel[];
    selectedClient: TdoClientConfigurationModel;
    selectedClientDataBackup: TdoClientConfigurationModel;

    isBusy: boolean = true;
    saveDisabled: boolean = false;
    enterpriseModel: TdoEnterpriseConfigurationModel;
    lastSelectedLogoPropertyName = '';

    reportLogoDocument: DocumentDataModel;
    letterLogoDocument: DocumentDataModel;
    emailLogoDocument: DocumentDataModel;
    xrayLogoDocument: DocumentDataModel;

    filetypes = 'image/png, image/jpeg';
    isUploadingImage = false;

    constructor(
        private enterpriseService: EnterpriseService,
        private snackBar: MatSnackBar,
        private fileManagerService: FileManagerService,
        private fileHelperService: FileHelperService,
        private globals: Globals,
        private cd: ChangeDetectorRef,
        private dialog: MatDialog,
        public configurationService: ConfigurationService,
        private localStorageService: LocalStorageService
    ) {
    }

    ngOnInit(): void {
        this.enterpriseService.getEnterpriseById(this.localStorageService.enterpriseId).subscribe((res) => {
            this.enterpriseModel = res;
        });

        this.enterpriseService.getClients().subscribe((data) => {
            if (data.length > 0) {
                this.clientList = data;


                this.setJsonFieds();


                this.selectedClient = this.clientList[0];
                this.getSelectedClientLogos();

                // load tdo table
                // this.refreshTableViewData(data);
            }
        }, err => {
            console.log(err);
            this.isBusy = false;
        });
    }


    onShowAllChange()  {
      if(this.selectedClient.isShowContactedAndStandard) {
        this.selectedClient.isShowStandardFee  = true;
        this.selectedClient.isShowContractedFee = true;
      }
      else {
        // this.selectedClient.isShowStandardFee  = false;
        // this.selectedClient.isShowContractedFee = false;

      }

    }


  onShowCChange()  {
    if(this.selectedClient.isShowContractedFee==false) {
      this.selectedClient.isShowContactedAndStandard=false;
    }


  }
  onShowSChange()  {
    if(this.selectedClient.isShowStandardFee==false) {
      this.selectedClient.isShowContactedAndStandard=false;
    }


  }



    setJsonFieds()  {
      this.clientList.forEach(a => {
        if (a.ARReportingOptionsJSON) {
          const b = JSON.parse(a.ARReportingOptionsJSON);
          a.isShowContractedFee = b.isShowContractedFee;
          a.isShowStandardFee = b.isShowStandardFee;
          a.isShowContactedAndStandard = b.isShowContactedAndStandard;
        }
        else {
          a.ARReportingOptionsJSON = JSON.stringify(
            {
              isShowContractedFee: false,
              isShowStandardFee : false,
              isShowContactedAndStandard : false
            });
          a.isShowContractedFee = false;
          a.isShowStandardFee = false;
          a.isShowContactedAndStandard = false;
        }
      });

    }

    getSelectedClientLogos() {
        const docIds: string[] = [];
        if (this.selectedClient.LogoReport_DocumentID && this.selectedClient.LogoReport_DocumentID !== Constants.emptyGuid) {
            docIds.push(this.selectedClient.LogoReport_DocumentID);
        }
        if (this.selectedClient.LogoLetter_DocumentID && this.selectedClient.LogoLetter_DocumentID !== Constants.emptyGuid) {
            docIds.push(this.selectedClient.LogoLetter_DocumentID);
        }
        if (this.selectedClient.LogoEmail_DocumentID && this.selectedClient.LogoEmail_DocumentID !== Constants.emptyGuid) {
            docIds.push(this.selectedClient.LogoEmail_DocumentID);
        }
        if (this.selectedClient.LogoXray_DocumentID && this.selectedClient.LogoXray_DocumentID !== Constants.emptyGuid) {
            docIds.push(this.selectedClient.LogoXray_DocumentID);
        }

        this.fileManagerService.getDocuments(docIds).subscribe((res) => {
            this.reportLogoDocument = res.find(p => p.DocumentID === this.selectedClient.LogoReport_DocumentID);
            this.letterLogoDocument = res.find(p => p.DocumentID === this.selectedClient.LogoLetter_DocumentID);
            this.emailLogoDocument = res.find(p => p.DocumentID === this.selectedClient.LogoEmail_DocumentID);
            this.xrayLogoDocument = res.find(p => p.DocumentID === this.selectedClient.LogoXray_DocumentID);
        });
    }

    // Data change
    refreshTableViewData(models: TdoClientConfigurationModel[]) {
        this.clientTable.updateData(models);
    }

    onSave(event?) {
    // save to db
      this.selectedClient.ARReportingOptionsJSON =
        JSON.stringify(
        {
          isShowContractedFee: this.selectedClient.isShowContractedFee,
          isShowStandardFee : this.selectedClient.isShowStandardFee,
          isShowContactedAndStandard : this.selectedClient.isShowContactedAndStandard
        });

        this.enterpriseService.saveTDOClient(this.selectedClient).subscribe(data => {
            if (data) {
                this.configurationService.setClean();
                const idx = this.clientList.findIndex(p => p.TDOCID === this.selectedClient.TDOCID);
                if (idx > -1) {
                    this.clientList.splice(idx, 1, data);
                }
                this.selectedClient = data;
                this.setJsonFieds();
                this.refreshTableViewData(this.clientList);
                this.clientTable.selectionControl.select(this.selectedClient);
                // save successful
                this.createMessage('Practice Details Saved', 'Success');
                /* this.saveDisabled = true;*/
            }
        });
    }

    onCancel(event) {
    /* this.saveDisabled = true;*/
        this.selectedClient = this.selectedClientDataBackup;
    }

    onEdit(event) {
        this.saveDisabled = false;
        const selectedClientDataBackupNew = new TdoClientConfigurationModel();
        selectedClientDataBackupNew.EmailReturnAddress = this.selectedClient.EmailReturnAddress;
        selectedClientDataBackupNew.SMSSendFromAddress = this.selectedClient.SMSSendFromAddress;
        selectedClientDataBackupNew.TDOGUID = this.selectedClient.TDOGUID;
        selectedClientDataBackupNew.TDOCID = this.selectedClient.TDOCID;
        selectedClientDataBackupNew.ARisComparing = this.selectedClient.ARisComparing;
        selectedClientDataBackupNew.ARisEstimating = this.selectedClient.ARisEstimating;
        selectedClientDataBackupNew.Name = this.selectedClient.Name;

        this.selectedClientDataBackup = selectedClientDataBackupNew;
    }

    createMessage(message, type) {
        this.snackBar.open(message, type, {
            duration: 3000,
            verticalPosition: 'top'
        });
    }

    onOpenFile(event, propertyName: string) {
        this.lastSelectedLogoPropertyName = propertyName;
        this.fileInput.nativeElement.value = null;
        this.fileInput.nativeElement.click();
    }

    fileSelected(files: FileList) {
        this.isUploadingImage = true;
        const fileModel = files[0];
        const uploadModel = new DocumentUploadModel();
        uploadModel.blob = fileModel;
        uploadModel.docClassId = DocumentClassEnum.Original;
        uploadModel.docTypeId = DocumentTypeEnum.Scan;
        uploadModel.hasAnnotation = false;
        uploadModel.docTagIds = [];

        this.fileManagerService.uploadDocuments([uploadModel]).subscribe((response) => {
            switch (this.lastSelectedLogoPropertyName) {
            case 'LogoReport_DocumentID':
                this.reportLogoDocument = response.documents[0];
                break;
            case 'LogoLetter_DocumentID':
                this.letterLogoDocument = response.documents[0];
                break;
            case 'LogoEmail_DocumentID':
                this.emailLogoDocument = response.documents[0];
                break;
            case 'LogoXray_DocumentID':
                this.xrayLogoDocument = response.documents[0];
                break;
            }
            this.selectedClient[this.lastSelectedLogoPropertyName] = response.documents[0].DocumentID;
            this.isUploadingImage = false;
            this.enterpriseService.saveTDOClient(this.selectedClient).subscribe(data => {
                if (data) {
                    // save successful
                    this.createMessage('Practice Details Saved', 'Success');
                    // this.saveDisabled = true;
                }
            });
        });
    }

    getImageUrl(propertyName: string, document: DocumentDataModel) {
        if (propertyName === 'LogoReport_DocumentID') {
            if (this.reportLogoDocument) {
                return this.fileManagerService.getDocumentUrlFromDocument(document);
            }
        } else if (propertyName === 'LogoLetter_DocumentID') {
            if (this.letterLogoDocument) {
                return this.fileManagerService.getDocumentUrlFromDocument(document);
            }
        } else if (propertyName === 'LogoEmail_DocumentID') {
            if (this.emailLogoDocument) {
                return this.fileManagerService.getDocumentUrlFromDocument(document);
            }
        } else if (propertyName === 'LogoXray_DocumentID') {
            if (this.xrayLogoDocument) {
                return this.fileManagerService.getDocumentUrlFromDocument(document);
            }
        }
    }

    setXrayPosition(position: number) {
        this.selectedClient.LogoXrayLocation = position;
    }

    setPosition($event: MatCheckboxChange, num: number) {
        this.selectedClient.LogoXrayLocation = num;
    }

    onNew(event: any) {
        const model = new TdoClientConfigurationModel();
        model.Name = 'New Practice';
        model.EnterpriseID = this.enterpriseModel.EnterpriseID;
        this.clientList.unshift(model);
        // this.refreshTableViewData(this.clientList);
        this.clientTable.updateData(this.clientList);
        this.clientTable.selectionControl.select(model);
        this.reportLogoDocument = null;
        this.xrayLogoDocument = null;
        this.emailLogoDocument = null;
        this.letterLogoDocument = null;
        this.selectedClient = model;

        this.configurationService.setDirty();
    }

    onTdoCidInputFinished(event: any) {
        this.selectedClient.TDOCID = event;
    }

    onNameInput(event) {
    /* const model = this.dataSource.data.find(p => p.model.TDOCID === this.selectedClient.TDOCID);
    model.model.Name = event.target.value;
    this.refreshTableViewData(this.clientList);*/
    }

    onNickNameInput(event) {
    /* const model = this.dataSource.data.find(p => p.model.TDOCID === this.selectedClient.TDOCID);
    model.model.ShortName = event.target.value;
    this.refreshTableViewData(this.clientList);*/
    }

    onTabChange(event: MatTabChangeEvent) {
        if (event.tab.textLabel === 'Logos') {
            this.onSave(null);
        }
    }

    openOrganizationDialog(viewOnly: boolean, organizationID: string) {
        const dialogRef = this.dialog.open(OrganizationConfigurationDialogComponent, {
            width: '700px',
            height: '900px',
            panelClass: 'dialog',
            data: {
                isDialogMode: true,
                isViewOnly: viewOnly,
                enumOrganizationTypeId: ORGANIZATION_TYPE.Practice, //   Constants.emptyGuid, // enterprise enumOrganizationTypeId
                TDOCID: this.selectedClient.TDOCID,
                organizationId: organizationID,
                showOrganizationTypeSelection: false
            }
        }).afterClosed().subscribe((data) => {
            if (data){
                if (this.selectedClient.OrganizationID === null || this.selectedClient.OrganizationID === Constants.emptyGuid){
                    this.selectedClient.OrganizationID = data;
                    this.onSave();
                }
            }
        });
    }

    onRowSelected(event: TdoTableSelectionEvent) {
        const l = this.configurationService.checkIsDirty();
        if (l) {
            l.subscribe((res) => {
                if (res) {
                    const model = event.model as TdoClientConfigurationModel;
                    this.selectedClient = model;
                    this.getSelectedClientLogos();
                    return;
                } else {
                    this.clientTable.selectionControl.select(this.selectedClient);
                }
            });
        } else {
            const model = event.model as TdoClientConfigurationModel;
            this.selectedClient = model;
            this.getSelectedClientLogos();
        }
    }
}
